import { Suspense, useEffect, useState } from 'react';

import { BrowserRouter, Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';

import { useAuthContext } from 'hooks/useAuth';
import { AuthContextProvider } from 'contexts/AuthContext';

import { CircularProgress } from '@mui/material';

import Home from 'pages/Home';
import Login from 'pages/Login';
import NotFound from 'pages/NotFound';
import DefaultLayout from 'layouts/DefaultLayout';
import NotePage from 'pages/NotePage';
import NoteAddPage from 'pages/NoteAddPage';
import NoteItemAddPage from 'pages/NoteItemAddPage';
import SignupPage from 'pages/SignupPage';

function App() {
  return (
    <BrowserRouter>
    <Suspense fallback={<CircularProgress/>}>
      <AuthContextProvider>
       
          <Routes>
            <Route element={<DefaultLayout/>}>  
              <Route element={<AuthGuard/>}>
                <Route path="/" element={<Home/>}/>
                <Route path="/note/add" element={<NoteAddPage/>}/>
                <Route path="/note/:noteId" element={<NotePage/>}/>
                <Route path="/note/:noteId/item/add" element={<NoteItemAddPage/>}/>
                <Route path="*" element={<NotFound/>}/>
              </Route>
            </Route>
            <Route path="/login" element={<Login/>}/>
            <Route path="/signup" element={<SignupPage/>}/>
          </Routes>
 
      </AuthContextProvider>
      </Suspense>
    </BrowserRouter>
  );
}

function AuthGuard() {
  const { user, loading } = useAuthContext();

  return !loading ? user ? <Outlet/> : <Navigate to="/login"/> : <CircularProgress/>;

  // useEffect(() => {
  //   if (loading) return;

  //   if (!user) {
  //     navigate("/login");
  //   }
  // }, [loading]);

  // if (loading) {
  //   return (
  //     <></>
  //   );
  // } else {
  //   if (user) {
  //     return (<>{children}</>)
  //   } else {
  //     navigate("/login")
  //   }
  // }
}

export default App;
